import { createBrowserRouter } from 'react-router-dom';

// Layouts (route group wrappers, replacing the Next.js layout.tsx files)
import { AdminLayout } from '@/app/layouts/AdminLayout';
import { AuthLayout } from '@/app/layouts/AuthLayout';
import { DashboardLayout } from '@/app/layouts/DashboardLayout';

import ChildSafetyPage from '@/app/child-safety/page';
import NotFoundPage from '@/app/not-found';
// Public
import HomePage from '@/app/page';

import ForgotPasswordPage from '@/app/(auth)/forgot-password/page';
// Auth group
import LoginPage from '@/app/(auth)/login/page';
import RegisterPage from '@/app/(auth)/register/page';

import ChatDetailPage from '@/app/(dashboard)/chat/[converseId]/page';
import ChatListPage from '@/app/(dashboard)/chat/page';
// Dashboard group
import DashboardPage from '@/app/(dashboard)/dashboard/page';
import MeetAcceptedPage from '@/app/(dashboard)/interactions/meet-accepted/page';
import MeetRefusedPage from '@/app/(dashboard)/interactions/meet-refused/page';
import MeetRequestsPage from '@/app/(dashboard)/interactions/meet-requests/page';
import TrustAcceptedPage from '@/app/(dashboard)/interactions/trust-accepted/page';
import TrustReceivedPage from '@/app/(dashboard)/interactions/trust-received/page';
import TrustSentPage from '@/app/(dashboard)/interactions/trust-sent/page';
import VisitsPage from '@/app/(dashboard)/interactions/visits/page';
import MemberProfilePage from '@/app/(dashboard)/profile/[nodeId]/page';
import MyProfilePage from '@/app/(dashboard)/profile/page';
import ProfilesPage from '@/app/(dashboard)/profiles/page';
import SettingsPage from '@/app/(dashboard)/settings/page';

import AdminMeetingsPage from '@/app/admin/meetings/page';
// Admin group
import AdminPage from '@/app/admin/page';
import AdminPhotosPage from '@/app/admin/photos/page';
import AdminQuestionsPage from '@/app/admin/questions/page';
import AdminStatsPage from '@/app/admin/stats/page';
import AdminUserDetailPage from '@/app/admin/users/[nodeId]/page';
import AdminUsersPage from '@/app/admin/users/page';

export const router = createBrowserRouter([
  { path: '/', element: <HomePage /> },
  { path: '/child-safety', element: <ChildSafetyPage /> },
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/register', element: <RegisterPage /> },
      { path: '/forgot-password', element: <ForgotPasswordPage /> },
    ],
  },
  {
    element: <DashboardLayout />,
    children: [
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/profiles', element: <ProfilesPage /> },
      { path: '/profile', element: <MyProfilePage /> },
      { path: '/profile/:nodeId', element: <MemberProfilePage /> },
      { path: '/chat', element: <ChatListPage /> },
      { path: '/chat/:converseId', element: <ChatDetailPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/interactions/visits', element: <VisitsPage /> },
      { path: '/interactions/trust-received', element: <TrustReceivedPage /> },
      { path: '/interactions/trust-sent', element: <TrustSentPage /> },
      { path: '/interactions/trust-accepted', element: <TrustAcceptedPage /> },
      { path: '/interactions/meet-requests', element: <MeetRequestsPage /> },
      { path: '/interactions/meet-accepted', element: <MeetAcceptedPage /> },
      { path: '/interactions/meet-refused', element: <MeetRefusedPage /> },
    ],
  },
  {
    element: <AdminLayout />,
    children: [
      { path: '/admin', element: <AdminPage /> },
      { path: '/admin/users', element: <AdminUsersPage /> },
      { path: '/admin/users/:nodeId', element: <AdminUserDetailPage /> },
      { path: '/admin/photos', element: <AdminPhotosPage /> },
      { path: '/admin/meetings', element: <AdminMeetingsPage /> },
      { path: '/admin/questions', element: <AdminQuestionsPage /> },
      { path: '/admin/stats', element: <AdminStatsPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
